import React from "react";
import { CheckCircle, Info } from "lucide-react";

const ResultsStep = ({
  t,
  currentTheme,
  modalStyles,
  importResults,
  isAr = false,
}) => {
  return (
            <div>
              <div style={modalStyles.statsGrid}>
                <div style={modalStyles.statCard}>
                  <div
                    style={{
                      ...modalStyles.statValue,
                      color: currentTheme.colors.primary,
                    }}
                  >
                    {importResults?.total || 0}
                  </div>
                  <div style={modalStyles.statLabel}>{t("total")}</div>
                </div>
                <div style={modalStyles.statCard}>
                  <div
                    style={{
                      ...modalStyles.statValue,
                      color: currentTheme.colors.success,
                    }}
                  >
                    {importResults?.successful || 0}
                  </div>
                  <div style={modalStyles.statLabel}>{t("successful")}</div>
                </div>
                <div style={modalStyles.statCard}>
                  <div
                    style={{
                      ...modalStyles.statValue,
                      color: currentTheme.colors.danger,
                    }}
                  >
                    {importResults?.failed || 0}
                  </div>
                  <div style={modalStyles.statLabel}>{t("failed")}</div>
                </div>
                <div style={modalStyles.statCard}>
                  <div
                    style={{
                      ...modalStyles.statValue,
                      color: currentTheme.colors.warning,
                    }}
                  >
                    {importResults?.skipped || 0}
                  </div>
                  <div style={modalStyles.statLabel}>{t("skipped")}</div>
                </div>
              </div>

              {importResults?.successful > 0 && (
                <div style={modalStyles.successBox}>
                  <CheckCircle
                    size={20}
                    style={{ marginInlineEnd: "8px", verticalAlign: "middle" }}
                  />
                  <span style={{ fontSize: "14px", fontWeight: "600" }}>
                    {t("successMessage").replace(
                      "{count}",
                      importResults.successful,
                    )}
                  </span>
                </div>
              )}

              {(importResults?.created > 0 || importResults?.replaced > 0) && (
                <div
                  data-testid="import-locked-notice"
                  style={{
                    margin: "12px 0",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid rgba(245,158,11,0.35)",
                    background: "rgba(245,158,11,0.08)",
                    fontSize: "13px",
                    color: currentTheme.colors.textPrimary,
                    lineHeight: 1.6,
                  }}
                >
                  <div style={{ fontWeight: 600 }}>
                    {isAr
                      ? `تم إنشاء ${importResults.created || 0} راتب واستبدال ${importResults.replaced || 0} راتب.`
                      : `${importResults.created || 0} payroll(s) created, ${importResults.replaced || 0} replaced.`}
                  </div>
                  <div style={{ color: currentTheme.colors.textSecondary }}>
                    {isAr
                      ? "الرواتب المستوردة مقفلة: تحتفظ بالقيم المستوردة ولا يعيد النظام حسابها أو تعديلها. القيم غير الموجودة في الملف تم حسابها مرة واحدة عند الاستيراد."
                      : "Imported payrolls are locked: they keep the imported values and the system will not recalculate or change them. Values missing from the file were calculated once, at import."}
                  </div>
                </div>
              )}

              {importResults?.kept && importResults.kept.length > 0 && (
                <div
                  data-testid="import-kept-list"
                  style={{
                    border: "1px solid rgba(245,158,11,0.35)",
                    borderRadius: "10px",
                    overflow: "hidden",
                    marginBottom: "12px",
                  }}
                >
                  <div style={{ padding: "12px 16px", background: "rgba(245,158,11,0.10)", fontWeight: 600, color: "#d97706", fontSize: "14px" }}>
                    {isAr ? `رواتب تم الإبقاء عليها (${importResults.kept.length})` : `Existing payrolls kept (${importResults.kept.length})`}
                  </div>
                  <div style={{ padding: "12px 16px", maxHeight: "220px", overflowY: "auto" }}>
                    {importResults.kept.map((k, i) => (
                      <div key={i} style={{ fontSize: "12px", marginBottom: "8px", color: currentTheme.colors.textPrimary }}>
                        <strong>{k.clientCode}</strong> — {k.year}-{String(k.month).padStart(2, "0")}: {k.reason}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {importResults?.errors && importResults.errors.length > 0 && (
                <div
                  style={{
                    border: `1px solid ${currentTheme.colors.danger}30`,
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      padding: "12px 16px",
                      background: `${currentTheme.colors.danger}10`,
                      borderBottom: `1px solid ${currentTheme.colors.danger}30`,
                      fontWeight: "600",
                      color: currentTheme.colors.danger,
                      fontSize: "14px",
                    }}
                  >
                    Errors ({importResults.errors.length})
                  </div>
                  <div
                    style={{
                      padding: "16px",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  >
                    {importResults.errors.map((error, index) => (
                      <div
                        key={index}
                        style={{
                          padding: "12px",
                          background: currentTheme.colors.inputBackground,
                          borderRadius: "8px",
                          marginBottom: "8px",
                          border: `1px solid ${currentTheme.colors.border}`,
                        }}
                      >
                        <div
                          style={{
                            color: currentTheme.colors.textPrimary,
                            fontWeight: "600",
                            marginBottom: "4px",
                            fontSize: "13px",
                          }}
                        >
                          {t("row")} {error.row} - {t("employee")}{" "}
                          {error.clientCode || error.infinityCode || t("unknown")}
                        </div>
                        <div
                          style={{
                            color: currentTheme.colors.danger,
                            fontSize: "12px",
                          }}
                        >
                          {error.error || error.errors?.join(", ")}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div style={modalStyles.infoBox}>
                <Info
                  size={18}
                  style={{ marginInlineEnd: "8px", verticalAlign: "middle" }}
                />
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  {t("recordsCreated")}
                </span>
              </div>
            </div>
          );
};

export default ResultsStep;